export default "__VITE_ASSET__GIlLSUJk__"